module.exports = __webpack_public_path__ + "img/tp-bar.c3d417a9.png";